var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 615,
    height: 611,
    style: {
      fill: "rgb(45,154,249)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-11.6596,9.50235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 286,
    r: 184,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.871908,0,0,0.943925,20.2344,11.1589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201,199C201,199 233.848,217.862 269,224C304.152,230.138 286,250 286,250L267,265C267,265 233.806,273.028 234,288C234.194,302.972 224,306 224,306C224,306 193.476,285.021 193,263C192.524,240.979 188.664,250.404 168,243C147.336,235.596 165,220 165,220L201,199Z",
    style: {
      fill: "rgb(45,154,249)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451,300C451,300 438.421,296.382 432,310.9C425.579,325.418 438,340 438,340C438,340 458.92,340.417 451,365C443.08,389.583 472,337 472,337L473,295.502L451,300Z",
    style: {
      fill: "rgb(45,154,249)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.598,199L436,195.565C436,195.565 458.203,210.429 465,249.5C471.797,288.571 465,276 465,276L420,286L412.598,270L430.157,249.5L412.598,199Z",
    style: {
      fill: "rgb(45,154,249)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,141C244,141 302.948,124.037 343,147C383.052,169.963 345.978,179.345 321,172C296.022,164.655 244,141 244,141Z",
    style: {
      fill: "rgb(45,154,249)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.968,265C157.968,265 168.151,267.705 190,294C211.849,320.295 186.074,323.251 208,329C229.926,334.749 224.327,361 224.327,361L218,381C218,381 200.353,399.362 215,409C229.647,418.638 224.327,439 224.327,439L185,423L157.968,375C157.968,375 141.666,328.631 157.968,265Z",
    style: {
      fill: "rgb(45,154,249)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.883984,0,0,0.785229,6.84892,59.2769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,230C328,230 401.217,200.118 414,182C426.783,163.882 431.445,180.517 431,181C430.555,181.483 440,199 440,199L451,211L459,229C459,229 456.578,250.966 434,245C411.422,239.034 420,265 420,265L392,276L360,265C360,265 301.436,279.033 328,230Z",
    style: {
      fill: "rgb(45,154,249)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330,276L350,292C350,292 353.492,315.385 337,315C320.508,314.615 321.088,295 321.088,295L330,276Z",
    style: {
      fill: "rgb(45,154,249)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-38.0566,22.9216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.697,325C335.697,325 412.399,321.637 423,306C433.601,290.363 434.386,277.732 440,300C445.614,322.268 434,344 434,344C434,344 414.437,355.846 416,376C417.563,396.154 408,416 408,416C408,416 383.933,418.795 356,391C328.067,363.205 351.346,352.214 335.697,339C320.048,325.786 335.697,325 335.697,325Z",
    style: {
      fill: "rgb(45,154,249)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.2dc578aa6de4923382d7c5ef449c04f1.svg";
export { ForwardRef as ReactComponent };